/**
 * Best-effort parse from free-text class/grade (e.g. "Class 11", "10th").
 * @returns {9|10|11|12|null}
 */
export function parseAssessmentGradeFromText(raw) {
  const s = String(raw || '')
    .trim()
    .toLowerCase();
  if (!s) return null;
  if (/\b12th|twelfth|class\s*12\b|\bstd\.?\s*12\b/.test(s)) return 12;
  if (/\b11th|eleventh|class\s*11\b|\bstd\.?\s*11\b/.test(s)) return 11;
  if (/\b10th|tenth|class\s*10\b|\bstd\.?\s*10\b/.test(s)) return 10;
  if (/\b9th|ninth|class\s*9\b|\bstd\.?\s*9\b/.test(s)) return 9;
  if (/\b(?:grade|class|std\.?)\s*(9|1[0-2])\b/.test(s)) {
    const m = s.match(/\b(?:grade|class|std\.?)\s*(9|1[0-2])\b/);
    if (m) return Number(m[1]);
  }
  const digit = s.match(/\b(9|1[0-2])\b/);
  if (digit) return Number(digit[1]);
  return null;
}
